import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useIssuesStore } from "@/stores/pm/hooks/usePMStore";
import { PM_ISSUE_LOAD_CEILING } from "@/domains/pm/constants";

/**
 * One line telling the reader that what they are looking at is not yet, or not
 * quite, the whole scope — or null when it is.
 *
 * The issue list loads a building's entire scope, but a large one arrives over
 * several seconds and a very large one stops at PM_ISSUE_LOAD_CEILING. Both
 * states have to be visible: a list that is still filling looks identical to a
 * list that has ended, and a reader who cannot tell them apart concludes the
 * missing issues do not exist.
 *
 * Shared by the list and the kanban board, which render it in different
 * markup, so this returns the text rather than an element. Read inside an
 * `observer` component — it tracks the store.
 */
export function useIssueLoadNotice(): string | null {
  const { t } = useLanguage();
  const issuesStore = useIssuesStore();

  if (issuesStore.truncated) {
    return t.pm.issues.loadCeiling.replace("{count}", String(PM_ISSUE_LOAD_CEILING));
  }
  if (issuesStore.isLoadingMore) return t.pm.issues.loadingMore;
  return null;
}
